<template>
  <div class="header">
<!--    <van-badge :content="number" class="button-div-b" max="99">
      <img src="@/assets/imgs/personal/msg.png" @click="toNewsList"/>
    </van-badge>-->
    <img src="@/assets/imgs/personal/setting.png" @click="setUp"/>
    <img src="@/assets/imgs/personal/msg.png" @click="toNewsList"/>
  </div>
</template>
<script>
export default {
  name: "PersonalHeader",
  props: {
    number: {
      default: 0,
      type: Number
    }
  },
  methods: {
    toNewsList() {
      this.$router.push("/news");
    },
    setUp() {
      this.$router.push("/setUp");
    },
  }
};
</script>
<style lang="stylus" scoped>
@import '~@/assets/styles/varibles.styl'
.header
  height 0.4rem
  padding 0.88rem 0 0.18rem
  float right
  font-size 0.48rem
  img{
    margin-left 0.38rem
    width: 0.48rem;
    height: 0.48rem;
    float right
  }
</style>
